import styled from 'styled-components';

export const StyledRefreshBtn = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;

  svg {
    margin-top: -6px;
  }

  button {
    border-width: 1px;
  }
`;
